<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              Enviar Notificações
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!--           <b-breadcrumb
            :items="[
              {
                text: 'Enviar Notificações',
                href: '#/distributors',
              },
              {
                text: 'Cadastro de Distribuidoras',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb> -->
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group label="Título">
                <b-form-input
                  v-model="state.title"
                  required
                  placeholder="Informe o título"
                  :state="isOk('title')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('title')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Mensagem">
                <b-form-textarea
                  v-model="state.message"
                  required
                  placeholder="Informe a mensagem"
                  :state="isOk('message')"
                ></b-form-textarea>
                <b-form-invalid-feedback>{{
                  getError('message')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox
                  v-model="state.showPopup"
                  required
                  :state="isOk('showPopup')"
                  >Mostrar em Popup</b-form-checkbox
                >
                <b-form-invalid-feedback>{{
                  getError('showPopup')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox
                  v-model="state.sendAll"
                  required
                  :state="isOk('sendAll')"
                  >Enviar para todos os usuários</b-form-checkbox
                >
                <b-form-invalid-feedback>{{
                  getError('sendAll')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Categoria da mensagem"
                label-for="input-1"
              >
                <b-form-select
                  v-model="state.category"
                  :options="state.categories"
                  :state="isOk('category')"
                ></b-form-select>
                <b-form-invalid-feedback>{{
                  getError('category')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                label="Perfil"
                label-for="input-group-3"
              >
                <select
                  v-model="state.selectedProfile"
                  @change="filterByProfile(state.selectedProfile)"
                  class="form-control"
                >
                  <option disabled value>Selecione o perfil</option>
                  <option value=""></option>
                  <option value="consumer">Consumidor</option>
                  <option value="trader">Comercializador</option>
                  <option value="investor">Investidor</option>
                </select>
                <div :class="{ 'is-invalid': !isOk('profile') }"></div>
                <b-form-invalid-feedback v-if="isOk('profile') === false">{{
                  getError('profile')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Seleção de usuários"
                label-for="input-1"
              >
                <b-form-select
                  v-model="state.selectedUsers"
                  :options="state.clientsFiltered"
                  :disabled="state.sendAll"
                  :multiple="true"
                ></b-form-select>
                <!--                 <div class="mt-3">
                  Selecionados: <strong>{{ state.selectedUsers }}</strong>
                </div> -->
              </b-form-group>

              <submit-button
                v-bind:action="() => send()"
                v-bind:label="'Enviar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';

const API = new Api();

export default {
  name: 'notification-edit',
  components: {},
  data: function() {
    return {
      selected: null,
      state: {
        sendAll: false,
        selectedUsers: [],
        clients: [],
        clientsFiltered: [],
        state: '',
        type: '',
        region: '',
      },
      viewData: {
        id: 0,
        loading: false,
        errors: [],
        states: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    const _id = this.$route.params ? this.$route.params.id : 0;
    this.viewData.id = _id;
    try {
      this.viewData.loading = true;

      const result = await API.post('/execute', {
        path: '/users-all',
        method: 'get',
      });

      this.state.clients = Object.keys(result.model)
        .map(item => {
          return result.model[item.toString()];
        })
        .map(item => {
          return {
            value: item.user.id,
            profile: item.profile,
            text: `${item.user.name} - ${item.user.phone} - ${
              item.profile === 'investor'
                ? 'Investidor'
                : item.profile === 'consumer'
                ? 'Consumidor'
                : 'Comercializador'
            }`,
          };
        });

      this.state.clients.sort((a, b) => {
        const nameA = a.text.toUpperCase();
        const nameB = b.text.toUpperCase();
        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
      });

      this.state.clientsFiltered = this.state.clients;

      this.viewData.loading = false;
    } catch (ex) {
      this.$toast.error(helpers.getFirstError(ex));
    }

    this.state.selectedUsers = [];
    this.state.categories = [
      { value: 'WEATHER', text: 'Clima' },
      { value: 'FINANCE', text: 'Financeira' },
      { value: 'GENERAL', text: 'Geral' },
    ];
  },
  methods: {
    filterByProfile(sValue) {
      if (sValue && sValue.length > 0) {
        this.state.clientsFiltered = this.state.clients.filter(item => {
          return item.profile === sValue;
        });
      } else {
        this.state.clientsFiltered = this.state.clients;
      }
    },
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isNumber($event) {
      return helpers.isNumber($event);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    updateUrl(url) {
      this.state.url = url;
    },
    setLoadingPhoto(loading) {
      this.viewData.loadingPhoto = loading;
    },
    async send() {
      try {
        let data = _.cloneDeep(this.state);

        const result = await API.post('/execute', {
          path: `/notification`,
          method: 'post',
          data: { ...data, isPopup: this.state.showPopup ? 1 : 0 },
        });

        this.$bvToast.toast(`Notificação enviada com sucesso`, {
          variant: 'success',
          title: 'Sucesso',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000,
          appendToast: false,
        });

        //this.$router.push('/notifications');
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
  },
};
</script>
